var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PageItem82873"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.5,167c46.1158,0,83.5-37.3842,83.5-83.5S129.6158,0,83.5,0,0,37.3842,0,83.5s37.3842,83.5,83.5,83.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "PageItem83101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.2879,69.0176h-9.1013v22.785c1.4649.434,4.426.961,8.0104.961,8.7584,0,14.026-5.022,14.026-12.152,0-6.634-4.9558-11.594-12.935-11.594Zm.0312,17.608c-.8104,0-1.5896-.031-2.3377-.093v-11.439h2.4935c3.4909,0,5.6104,2.542,5.6104,5.673,0,3.379-1.9636,5.859-5.7662,5.859Zm17.1425,5.642h7.1376v-23.25h-7.1376v23.25Zm27.5216-23.25v10.912l-14.8675-11.16h-.561v23.498h6.9506v-10.881l14.8675,11.16h.5922v-23.529h-6.9818Zm25.8383,5.983c2.5558,0,5.1117.837,6.4831,1.612v-6.293c-1.3091-.868-3.8649-1.705-7.2935-1.705-8.3221,0-13.8389,5.053-13.8389,12.4,0,7.13,5.2052,11.749,12.935,11.749,3.6779,0,6.7325-1.023,8.1351-2.046v-10.788h-6.2338v6.324c-.4364.124-.9662.217-1.5584.217-3.6779,0-6.1402-2.046-6.1402-5.394,0-3.844,2.7429-6.076,7.5117-6.076Zm17.7656,11.377v-3.317h8.9766v-5.332h-8.9766v-2.821h9.5376v-5.89h-16.1766v23.25h16.3013v-5.89h-9.6623Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinge);
export default __webpack_public_path__ + "static/media/Dinge.3c4fba71389549070fa3fb6954c62857.svg";
export { ForwardRef as ReactComponent };